import { Button, IconButton } from '@ace-clublabs/shared-component-library';

interface SearchButtonProps {
  onClick?: () => void;
  loading?: boolean;
  label?: string;
}

const SearchButton: React.FC<SearchButtonProps> = ({
  onClick,
  loading,
  label,
}) => {
  return (
    <>
      {label ? (
        <Button
          label={label}
          onClick={onClick}
          variant='contained'
          data-testid='search-button'
          loading={loading}
          sx={{
            height: 40,
          }}
        />
      ) : (
        <IconButton
          onClick={onClick}
          data-testid='search-button-icon'
          iconName='magnifying-glass-regular'
          loading={loading}
          size='small'
          sx={{
            height: 41,
            width: 46,
            backgroundColor: '#016bcd',
            borderRadius: 2,
            '& path': {
              fill: 'white',
            },
            '& svg': {
              width: '16px',
              height: '16px',
            },
          }}
        />
      )}
    </>
  );
};

export default SearchButton;
